// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__DiscountCodesController from "./admin/discount_codes_controller"
application.register("admin--discount-codes", Admin__DiscountCodesController)

import AnchorLinkController from "./anchor_link_controller"
application.register("anchor-link", AnchorLinkController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CarouselLoaderController from "./carousel_loader_controller"
application.register("carousel-loader", CarouselLoaderController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import Cartzilla__BindedLabelController from "./cartzilla/binded_label_controller"
application.register("binded-label", Cartzilla__BindedLabelController)

import Cartzilla__CountInputController from "./cartzilla/count_input_controller"
application.register("count-input", Cartzilla__CountInputController)

import Cartzilla__SelectBoxController from "./cartzilla/select_box_controller"
application.register("select-box", Cartzilla__SelectBoxController)

import CaseConsiderationController from "./case_consideration_controller"
application.register("case-consideration", CaseConsiderationController)

import CheckVisibilityController from "./check_visibility_controller"
application.register("check-visibility", CheckVisibilityController)

import DataTableController from "./data_table_controller"
application.register("data-table", DataTableController)

import DisabledController from "./disabled_controller"
application.register("disabled", DisabledController)

import DismissErrorController from "./dismiss_error_controller"
application.register("dismiss-error", DismissErrorController)

import FormStateController from "./form_state_controller"
application.register("form-state", FormStateController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import GalleryUpdateController from "./gallery_update_controller"
application.register("gallery-update", GalleryUpdateController)

import LogoPersonalizationsController from "./logo_personalizations_controller"
application.register("logo-personalizations", LogoPersonalizationsController)

import LogoSelectionController from "./logo_selection_controller"
application.register("logo-selection", LogoSelectionController)

import ManageGalleryController from "./manage_gallery_controller"
application.register("manage-gallery", ManageGalleryController)

import ParentClickController from "./parent_click_controller"
application.register("parent-click", ParentClickController)

import PositionPickerController from "./position_picker_controller"
application.register("position-picker", PositionPickerController)

import ResizableRectangleController from "./resizable_rectangle_controller"
application.register("resizable-rectangle", ResizableRectangleController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ShippingController from "./shipping_controller"
application.register("shipping", ShippingController)

import ShowModalController from "./show_modal_controller"
application.register("show-modal", ShowModalController)

import SortableFormController from "./sortable_form_controller"
application.register("sortable-form", SortableFormController)

import SquarePaymentsController from "./square_payments_controller"
application.register("square-payments", SquarePaymentsController)

import SubtotalController from "./subtotal_controller"
application.register("subtotal", SubtotalController)

import SwapElementsController from "./swap_elements_controller"
application.register("swap-elements", SwapElementsController)

import ToggleCheckoutController from "./toggle_checkout_controller"
application.register("toggle-checkout", ToggleCheckoutController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UpcaseFieldsController from "./upcase_fields_controller"
application.register("upcase-fields", UpcaseFieldsController)
